import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskListComponent, UpdateProgressComponent } from './task-list/task-list.component';
import { AuthGuard, ModuleGuard } from '../../../core/auth';
import { RouterModule, Routes } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PartialsModule } from '../../partials/partials.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../../core/core.module';
import { TaskByCategoryComponent } from './task-by-category/task-by-category.component';
import { AccordionComponent } from './task-by-category/accordion/accordion.component';
import { TaskFilterButtonComponent } from './task-filter-button/task-filter-button.component';
import { TaskActionButtonComponent } from './task-action-button/task-action-button.component';
import { TaskSelectionBarComponent } from './task-selection-bar/task-selection-bar.component';

const routes: Routes = [
  {
    path: 'list',
    component: TaskListComponent,
    canActivate: [ModuleGuard, AuthGuard],
    data: { permissionName: 'accessToTaskModule' },
  },
  {
    path: 'groups',
    component: TaskByCategoryComponent,
    canActivate: [ModuleGuard, AuthGuard],
    data: { permissionName: 'accessToTaskModule' },
  },
];

@NgModule({
  declarations: [
    TaskListComponent,
    UpdateProgressComponent,
    TaskByCategoryComponent,
    AccordionComponent,
    TaskFilterButtonComponent,
    TaskActionButtonComponent,
    TaskSelectionBarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatDatepickerModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    PerfectScrollbarModule,
    MatTooltipModule,
    PartialsModule,
    MatButtonToggleModule,
    NgxPermissionsModule.forChild(),
    MatSelectModule,
    TranslateModule,
    MatDialogModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    CoreModule,
  ],
  providers: [ModuleGuard],
  exports: [
    TaskListComponent,
    TaskByCategoryComponent,
    AccordionComponent,
    TaskFilterButtonComponent,
    TaskActionButtonComponent,
    TaskSelectionBarComponent,
  ],
  entryComponents: [UpdateProgressComponent],
})
export class TaskModule {}
